module.exports = __webpack_public_path__ + "static/media/SECRET.bdfa751d.svg";